var exports = {
  "nM": "CrosspostPublishNudge.module__row___Ymtocm",
  "Io": "CrosspostPublishNudge.module__pill___Ymtocm",
  "Kk": "CrosspostPublishNudge.module__icon___Ymtocm",
  "Pf": "CrosspostPublishNudge.module__label___Ymtocm",
  "_4": "CrosspostPublishNudge.module__publishButton___Ymtocm",
  "r": "CrosspostPublishNudge.module__dismissButton___Ymtocm",
  "EL": "CrosspostPublishNudge.module__hideForeverButton___Ymtocm",
  "MW": "CrosspostPublishNudge.module__dismissIcon___Ymtocm",
};

module.exports = exports;
